/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
} from './OrderType';
import type { TradeExecution } from './TradeExecution';
import {
    TradeExecutionFromJSON,
    TradeExecutionFromJSONTyped,
    TradeExecutionToJSON,
} from './TradeExecution';
import type { TradeSide } from './TradeSide';
import {
    TradeSideFromJSON,
    TradeSideFromJSONTyped,
    TradeSideToJSON,
} from './TradeSide';

/**
 * 
 * @export
 * @interface BlockTradeWithExecution
 */
export interface BlockTradeWithExecution {
    /**
     * 
     * @type {string}
     * @memberof BlockTradeWithExecution
     */
    blockTradeId: string;
    /**
     * 
     * @type {number}
     * @memberof BlockTradeWithExecution
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof BlockTradeWithExecution
     */
    symbol: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof BlockTradeWithExecution
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {string}
     * @memberof BlockTradeWithExecution
     */
    brokerId: string;
    /**
     * 
     * @type {TradeSide}
     * @memberof BlockTradeWithExecution
     */
    side: TradeSide;
    /**
     * 
     * @type {number}
     * @memberof BlockTradeWithExecution
     */
    absTradeQuantity: number;
    /**
     * 
     * @type {OrderType}
     * @memberof BlockTradeWithExecution
     */
    orderType: OrderType;
    /**
     * 
     * @type {number}
     * @memberof BlockTradeWithExecution
     */
    limitPrice: number;
    /**
     * 
     * @type {Array<TradeExecution>}
     * @memberof BlockTradeWithExecution
     */
    tradeExecutions: Array<TradeExecution>;
}



/**
 * Check if a given object implements the BlockTradeWithExecution interface.
 */
export function instanceOfBlockTradeWithExecution(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "blockTradeId" in value;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "absTradeQuantity" in value;
    isInstance = isInstance && "orderType" in value;
    isInstance = isInstance && "limitPrice" in value;
    isInstance = isInstance && "tradeExecutions" in value;

    return isInstance;
}

export function BlockTradeWithExecutionFromJSON(json: any): BlockTradeWithExecution {
    return BlockTradeWithExecutionFromJSONTyped(json, false);
}

export function BlockTradeWithExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockTradeWithExecution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blockTradeId': json['block_trade_id'],
        'optimizationId': json['optimization_id'],
        'symbol': json['symbol'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'brokerId': json['broker_id'],
        'side': TradeSideFromJSON(json['side']),
        'absTradeQuantity': json['abs_trade_quantity'],
        'orderType': OrderTypeFromJSON(json['order_type']),
        'limitPrice': json['limit_price'],
        'tradeExecutions': ((json['trade_executions'] as Array<any>).map(TradeExecutionFromJSON)),
    };
}

export function BlockTradeWithExecutionToJSON(value?: BlockTradeWithExecution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'block_trade_id': value.blockTradeId,
        'optimization_id': value.optimizationId,
        'symbol': value.symbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'broker_id': value.brokerId,
        'side': TradeSideToJSON(value.side),
        'abs_trade_quantity': value.absTradeQuantity,
        'order_type': OrderTypeToJSON(value.orderType),
        'limit_price': value.limitPrice,
        'trade_executions': ((value.tradeExecutions as Array<any>).map(TradeExecutionToJSON)),
    };
}

